module.exports = __webpack_public_path__ + "img/community02.f831fa58.png";